{
    "v": "5.8.1",
    "fr": 30,
    "ip": 0,
    "op": 60,
    "w": 500,
    "h": 500,
    "nm": "01 View",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "parent": 5,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 16, "ix": 1 }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Eye line",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [50, 50, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.7, "y": 1 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [100.45, 0],
                                                    [0, 0],
                                                    [-100.45, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-100.45, 0],
                                                    [0, 0],
                                                    [100.45, 0]
                                                ],
                                                "v": [
                                                    [178.825, -10.036],
                                                    [-0.025, 80.905],
                                                    [-178.875, -10.036],
                                                    [-0.025, -100.976]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.7, "y": 1 },
                                        "o": { "x": 0.3, "y": 0 },
                                        "t": 13,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [100.45, 0],
                                                    [0, 0],
                                                    [-100.45, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-100.45, 0],
                                                    [0, 0],
                                                    [100.45, 0]
                                                ],
                                                "v": [
                                                    [178.825, -10.036],
                                                    [-0.025, 80.905],
                                                    [-178.875, -10.036],
                                                    [-0.025, -100.976]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.7, "y": 1 },
                                        "o": { "x": 0.3, "y": 0 },
                                        "t": 19,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [100.45, 0],
                                                    [0, 0],
                                                    [-100.45, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-100.45, 0],
                                                    [0, 0],
                                                    [100.45, 0]
                                                ],
                                                "v": [
                                                    [178.825, -10.036],
                                                    [-0.05, 17.905],
                                                    [-178.875, -10.036],
                                                    [-0.05, 19.024]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.7, "y": 1 },
                                        "o": { "x": 0.3, "y": 0 },
                                        "t": 25,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [100.45, 0],
                                                    [0, 0],
                                                    [-100.45, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-100.45, 0],
                                                    [0, 0],
                                                    [100.45, 0]
                                                ],
                                                "v": [
                                                    [178.825, -10.036],
                                                    [-0.025, 80.905],
                                                    [-178.875, -10.036],
                                                    [-0.025, -100.976]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.7, "y": 1 },
                                        "o": { "x": 0.3, "y": 0 },
                                        "t": 39.029,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [100.45, 0],
                                                    [0, 0],
                                                    [-100.45, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-100.45, 0],
                                                    [0, 0],
                                                    [100.45, 0]
                                                ],
                                                "v": [
                                                    [178.825, -10.036],
                                                    [-0.025, 80.905],
                                                    [-178.875, -10.036],
                                                    [-0.025, -100.976]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.7, "y": 1 },
                                        "o": { "x": 0.3, "y": 0 },
                                        "t": 44,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [100.45, 0],
                                                    [0, 0],
                                                    [-100.45, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-100.45, 0],
                                                    [0, 0],
                                                    [100.45, 0]
                                                ],
                                                "v": [
                                                    [178.825, -10.036],
                                                    [-0.05, 17.905],
                                                    [-178.875, -10.036],
                                                    [-0.05, 19.024]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 48.970703125,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [100.45, 0],
                                                    [0, 0],
                                                    [-100.45, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-100.45, 0],
                                                    [0, 0],
                                                    [100.45, 0]
                                                ],
                                                "v": [
                                                    [178.825, -10.036],
                                                    [-0.025, 80.905],
                                                    [-178.875, -10.036],
                                                    [-0.025, -100.976]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 16,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Mask",
            "parent": 1,
            "td": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [50, 50, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.7, "y": 1 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [100.45, 0],
                                                    [0, 0],
                                                    [-100.45, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-100.45, 0],
                                                    [0, 0],
                                                    [100.45, 0]
                                                ],
                                                "v": [
                                                    [178.825, -10.036],
                                                    [-0.025, 80.905],
                                                    [-178.875, -10.036],
                                                    [-0.025, -100.976]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.7, "y": 1 },
                                        "o": { "x": 0.3, "y": 0 },
                                        "t": 13,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [100.45, 0],
                                                    [0, 0],
                                                    [-100.45, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-100.45, 0],
                                                    [0, 0],
                                                    [100.45, 0]
                                                ],
                                                "v": [
                                                    [178.825, -10.036],
                                                    [-0.025, 80.905],
                                                    [-178.875, -10.036],
                                                    [-0.025, -100.976]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.7, "y": 1 },
                                        "o": { "x": 0.3, "y": 0 },
                                        "t": 19,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [100.45, 0],
                                                    [0, 0],
                                                    [-100.45, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-100.45, 0],
                                                    [0, 0],
                                                    [100.45, 0]
                                                ],
                                                "v": [
                                                    [178.825, -10.036],
                                                    [-0.05, 17.905],
                                                    [-178.875, -10.036],
                                                    [-0.05, 19.024]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.7, "y": 1 },
                                        "o": { "x": 0.3, "y": 0 },
                                        "t": 25,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [100.45, 0],
                                                    [0, 0],
                                                    [-100.45, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-100.45, 0],
                                                    [0, 0],
                                                    [100.45, 0]
                                                ],
                                                "v": [
                                                    [178.825, -10.036],
                                                    [-0.025, 80.905],
                                                    [-178.875, -10.036],
                                                    [-0.025, -100.976]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.7, "y": 1 },
                                        "o": { "x": 0.3, "y": 0 },
                                        "t": 39.029,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [100.45, 0],
                                                    [0, 0],
                                                    [-100.45, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-100.45, 0],
                                                    [0, 0],
                                                    [100.45, 0]
                                                ],
                                                "v": [
                                                    [178.825, -10.036],
                                                    [-0.025, 80.905],
                                                    [-178.875, -10.036],
                                                    [-0.025, -100.976]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.7, "y": 1 },
                                        "o": { "x": 0.3, "y": 0 },
                                        "t": 44,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [100.45, 0],
                                                    [0, 0],
                                                    [-100.45, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-100.45, 0],
                                                    [0, 0],
                                                    [100.45, 0]
                                                ],
                                                "v": [
                                                    [178.825, -10.036],
                                                    [-0.05, 17.905],
                                                    [-178.875, -10.036],
                                                    [-0.05, 19.024]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 48.970703125,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [100.45, 0],
                                                    [0, 0],
                                                    [-100.45, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-100.45, 0],
                                                    [0, 0],
                                                    [100.45, 0]
                                                ],
                                                "v": [
                                                    [178.825, -10.036],
                                                    [-0.025, 80.905],
                                                    [-178.875, -10.036],
                                                    [-0.025, -100.976]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 16,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "fl",
                    "c": { "a": 0, "k": [1, 0, 0, 1], "ix": 4 },
                    "o": { "a": 0, "k": 100, "ix": 5 },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Circle",
            "parent": 1,
            "tt": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.7, "y": 1 },
                            "o": { "x": 0.3, "y": 0 },
                            "t": 0,
                            "s": [49.975, 39.964, 0],
                            "to": [-17, 0, 0],
                            "ti": [-13, 0, 0]
                        },
                        {
                            "i": { "x": 0.7, "y": 1 },
                            "o": { "x": 0.3, "y": 0 },
                            "t": 14,
                            "s": [-52.025, 39.964, 0],
                            "to": [13, 0, 0],
                            "ti": [-17, 0, 0]
                        },
                        {
                            "i": { "x": 0.7, "y": 1 },
                            "o": { "x": 0.3, "y": 0 },
                            "t": 29,
                            "s": [127.975, 39.964, 0],
                            "to": [17, 0, 0],
                            "ti": [13, 0, 0]
                        },
                        { "t": 45, "s": [49.975, 39.964, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [-0.025, -10.036, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "rc",
                            "d": 1,
                            "s": { "a": 0, "k": [279, 297], "ix": 2 },
                            "p": { "a": 0, "k": [0, 0], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 4 },
                            "nm": "Rectangle Path 1",
                            "mn": "ADBE Vector Shape - Rect",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.901961023667, 0.379260014553, 0.063668000464, 1], "ix": 3 },
                            "o": { "a": 0, "k": 0, "ix": 4 },
                            "w": { "a": 0, "k": 16, "ix": 5 },
                            "lc": 1,
                            "lj": 1,
                            "ml": 4,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [-1.5, -22.5], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Rectangle 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, -16.742],
                                        [16.742, 0],
                                        [0, 16.742],
                                        [-16.742, 0]
                                    ],
                                    "o": [
                                        [0, 16.742],
                                        [-16.742, 0],
                                        [0, -16.742],
                                        [16.742, 0]
                                    ],
                                    "v": [
                                        [30.288, -10.036],
                                        [-0.025, 20.278],
                                        [-30.339, -10.036],
                                        [-0.025, -40.349]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 16,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [50.148, 0],
                                        [0, 50.148],
                                        [-50.148, 0],
                                        [0, -50.148]
                                    ],
                                    "o": [
                                        [-50.148, 0],
                                        [0, -50.148],
                                        [50.148, 0],
                                        [0, 50.148]
                                    ],
                                    "v": [
                                        [-0.025, 80.905],
                                        [-90.966, -10.036],
                                        [-0.025, -100.976],
                                        [90.916, -10.036]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.20000000298, 0.800000011921, 0.800000011921, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 16,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 3,
            "nm": "Zero | troke width - Color Ctrl",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
